/**
 * First, we will load all of this project's Javascript utilities and other
 * dependencies. Then, we will be ready to develop a robust and powerful
 * application frontend using useful Laravel and JavaScript libraries.
 */

require( './bootstrap' );

if ( document.querySelector( '#logout' ) ) {
	document.querySelector( '#logout' ).addEventListener( 'click', e => {
		e.preventDefault();
		axios.post( '/logout' )
		     .then( r => {
			     if ( r.status === 200 ) {
				     alert( '로그아웃 되었습니다.' );
				     location.href = '/';
			     }
		     } )
		     .catch( err => {
			     if ( err.response ) {
				     alert( err.response.data.message );
			     }
			     else {
				     alert( '오류 발생 : ' + err.message );
			     }
		     } )
	} )
}

const checkAll = document.querySelector( '#checkall' );
if ( checkAll ) {
	checkAll.addEventListener( 'click', event => {
		document.querySelectorAll( 'tbody input[type="checkbox"]' ).forEach( el => {
			el.checked = event.target.checked;
		} );
	} );
}

window.sendContact = ( f ) => {

	try {

		if ( !f.name.value ) throw { msg: '이름을 입력하세요.', obj: f.name };
		if ( !f.email.value ) throw { msg: '이메일을 입력하세요.', obj: f.email };
		if ( !f.title.value ) throw { msg: '제목을 입력하세요.', obj: f.title };
		if ( !f.message.value ) throw { msg: '메시지를 입력하세요.', obj: f.message };
		if ( f.message.value.length < 10 ) throw { msg: '메시지는 최소 10자 이상 입력하세요.', obj: f.message };

	}
	catch ( error ) {
		alert( error.msg );
		error.obj.focus();
		return false;
	}

	const fd = new FormData( f );
	axios.post( '/api/contact', fd )
	     .then( r => {
		     console.log( r );
		     if ( r.data.status === 200 ) {
			     alert( r.data.message );
			     f.reset();
		     }
		     else {
			     alert( r.data.message );
			     return false;
		     }

	     } )
	     .catch( err => {
		     if ( err.status === 422 ) {
			     console.error( err.status );
			     alert( err.response.data.errors.message.join( '\n\r' ) );
		     }
		     else {
			     alert( err.response.data.message );
		     }
	     } );
};

const contactForm = document.querySelector( '#contact-form' );
if ( contactForm ) {
	contactForm.addEventListener( 'submit', e => {
		e.preventDefault();
		sendContact( e.target );
	} );
}

const bookreviewSection = document.getElementById('bookreview');
if ( bookreviewSection ) {
	$(bookreviewSection).owlCarousel({
		                             loop:true,
		                             margin:10,
		                             lazyLoad:true,
		                             responsiveClass:true,
		                             responsive: {
			                             0:{
				                             items:1,
				                             nav:true
			                             },
			                             600: {
				                             items:2,
				                             nav:false
			                             },
			                             1000: {
				                             items:3,
				                             nav:false
			                             }
		                             }
	                             });
}


$( function () {
	$( '[data-toggle="tooltip"]' ).tooltip();
	$( '#flash-overlay-modal' ).modal();
	$( 'div.alert' ).not( '.alert-important' ).delay( 3000 ).fadeOut( 350 );
} );
